import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import PracticeAreas from "@/components/site/PracticeAreas";
import Attorney from "@/components/site/Attorney";
import Testimonials from "@/components/site/Testimonials";
import ConsultationCTA from "@/components/site/ConsultationCTA";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="bg-[#FBFBFB] text-slate-900 antialiased">
            <Toaster position="top-center" richColors />
            <Header />
            <main>
                <Hero />
                <Marquee />
                <About />
                <PracticeAreas />
                <Attorney />
                <Testimonials />
                <ConsultationCTA />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}

export default App;
